import React from "react";
import TableComponent from "../TableComponent";

interface ITableCard {
    title: string;
    data: any[];
    columns: any[];
    isLoading?: boolean;
    errorMessage?: string;
}

const TableCard: React.FC<ITableCard> = ({
    title,
    data,
    columns,
    isLoading,
    errorMessage,
}) => {
    return (
        <div
            className="flex items-start flex-col justify-between flex-1 rounded-[8px] border-darkcolor-400 border-[1px] text-neutral-25"
            style={{
                background:
                    "var(--Dark-Mode-Gradient-Cards, linear-gradient(181deg, #253240 -16.87%, rgba(37, 48, 64, 0.40) 35.14%))",
                    minHeight: "400px"
            }}
        >
            <div className="flex justify-between items-center w-full border-b-darkcolor-400 border-b-[1px] px-[24px] py-[20px]">
                <label className="text-[18px] font-semibold">{title}</label>
            </div>
            <div className="px-[24px] pt-[20px] pb-[10px] w-full flex-1">
                <TableComponent
                    data={data}
                    rowsPerPage={5}
                    columns={columns}
                    emptyIcon={true}
                    isLoading={isLoading}
                    overFlowClass="overflow-auto"
                    errorMessage={errorMessage}
                />
            </div>
        </div>
    );
};

export default TableCard;
